var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticClass:"sidebar"},[_vm._t("sidebar")],2),_c('div',{staticClass:"panel"},[_vm._t("panel")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }